const button = {
  "color": "inherit",
  "fontFamily": "inherit",
  "fontSize": "inherit",
  "lineHeight": "inherit",
  "cursor": "pointer",
  "minWidth": "0",
  "maxWidth": "none",
  "padding": "0",
  "margin": "0",
  "borderRadius": "0",
  "border": "0",
  "backgroundColor": "transparent",
  "touchAction": "manipulation",
  "&:focus": {
    "outline": "dashed 1px #53565a",
    "outlineOffset": "3px"
  }
};

export { button };
